import { Flight, ScheduleFlight } from "@models";
import { parse } from "date-fns";

const convertHoursMinToMinutes = (offset: string | undefined) => {
  if (!offset) return 0;
  const hours = parseInt(offset.split(':')[0]);
  const minutes = parseInt(offset.split(':')[1]);
  return (hours * 60) + minutes;
}

export const convertFlightsToActivities = (flights: Flight[]): ScheduleFlight[] => {
  return flights.map((flight: Flight) => ({
    uniqueId: "",
    activityType: "FLIGHT",
    activitySubType: "",
    activityCode: `MX${flight.flightNumber}`,
    startAirportCode: flight.scheduledDepartureAirport,
    endAirportCode: flight.scheduledArrivalAirport,
    start: flight.std,
    end: flight.sta,
    startLocalTimeDiff: convertHoursMinToMinutes(flight.offsetDa),
    endLocalTimeDiff: convertHoursMinToMinutes(flight.offsetAa),
    startBaseTimeDiff: convertHoursMinToMinutes(flight.offsetDa),
    endBaseTimeDiff: convertHoursMinToMinutes(flight.offsetAa),
    rosterDesignator: "",
    legalException: "",
    assignedRank: "",
    code: `MX${flight.flightNumber}`,
    refUniqueId: parseInt(flight.uniqueId || '0'),
  }));
}

export const parseDate = (dateStr: string): Date => {
  return parse(dateStr, 'MM/dd/yyyy', new Date());
}
